import React, { useEffect, useState } from 'react'
import { Row, Col, Affix } from 'antd'
import CardFile from '../../Components/FileUpload/CardFile'
import CardNotificationFile from '../../Components/FileUpload/CardNotificationFile'
import TitleGlobal from '../../Components/Global/TitleGlobal'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { ValidationUserReducer } from '../../Redux/Actions/Validations/Validations'
import SideMenu from '../../Components/Global/SideMenu'
import { useIdleTimer } from 'react-idle-timer'
import socket from '../../App/socket'
import {
    GetCardsFileUpload,
    RegisterUsersConnectedFileUploadReducer
} from '../../Redux/Actions/FileUpload/FileUpload'
import ModalItemNotification from '../../Components/FileUpload/ModalItemNotification'
import {
    funPermisosObtenidos,
    funPermisoAreaFileUpload
} from '../../Functions/funPermisos'
import NavegadorArriendos from '../../Components/Arriendos/NavegadorArriendos'

const FileUpload = () => {

    const timeout = 300000
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {
        rex_data_user_logingrow
    } = useSelector(({ loginGrow }) => loginGrow);

    const ValidateUser = async () => {
        const validate_user = await dispatch(ValidationUserReducer())
        if (!validate_user) {
            navigate('/login')
        }
    }

    const {
        rex_data_permissions_user
    } = useSelector(({ loginGrow }) => loginGrow)

    useEffect(() => {
        ValidateUser()
        dispatch(GetCardsFileUpload())
        socket.emit('reg-modules', { module: 'file-upload' }, { usuusuario: rex_data_user_logingrow.usuusuario })
    }, [])

    useEffect(() => {
        socket.on('get-users-modules', (data_users) => {
            dispatch(RegisterUsersConnectedFileUploadReducer(data_users))
        });

        return () => {
            socket.emit('unreg-modules', { module: 'file-upload' }, { usuusuario: rex_data_user_logingrow.usuusuario });
            socket.off('get-users-modules');
        };
    }, [])

    const onIdle = () => {
        socket.emit('reg-status-modules', { module: 'file-upload' }, { usuusuario: rex_data_user_logingrow.usuusuario }, false);
    }
    const onActive = () => {
        socket.emit('reg-status-modules', { module: 'file-upload' }, { usuusuario: rex_data_user_logingrow.usuusuario }, true);
    }

    useIdleTimer({
        onIdle,
        onActive,
        timeout,
        throttle: 500
    })

    const {
        rex_data_users_online
    } = useSelector(({ users }) => users);

    const {
        rex_users_file_upload_connected,
        rex_messages_notifications_upload_files,
        rex_cards_upload_file,
        rex_cards_total_upload_file,
        rex_show_notification_modal_upload_file
    } = useSelector(({ fileUpload }) => fileUpload);

    // Helper function to check if user has specific permission
    const hasPermission = (permissionSlug) => {
        return rex_data_permissions_user?.some(perm => perm.pemslug === permissionSlug) || false;
    };

    // Check permissions for different categories
    const hasArriendosPermission = hasPermission('peru.arriendos');
    const hasCanalModernoPermission = hasPermission('peru.canalmoderno');
    const hasFileUploadPermissions = (slug) => hasPermission(slug);

    // Filter and validate available categories
    const categoriasDisponibles = rex_cards_upload_file?.filter(category => {
        // Check if category has valid structure
        if (!category.name || !category.cards || !Array.isArray(category.cards)) {
            return false;
        }

        // Check permissions based on category name and card slugs
        if (category.name === 'Arriendo') {
            // For Arriendos category, user needs peru.arriendos permission
            return hasArriendosPermission;
        }

        if (category.name === 'Canal Moderno') {
            // For Canal Moderno, check if user has permissions for any of the cards
            const hasAnyCardPermission = category.cards.some(card => 
                card.slug && hasFileUploadPermissions(card.slug)
            );
            return hasAnyCardPermission;
        }

        if (category.name === 'Canal Tradicional') {
            // For Canal Tradicional, check if user has permissions for any of the cards
            const hasAnyCardPermission = category.cards.some(card => 
                card.slug && hasFileUploadPermissions(card.slug)
            );
            return hasAnyCardPermission;
        }

        // For other categories, check if user has permissions for at least one card
        const hasAnyCardPermission = category.cards.some(card => 
            card.slug && hasFileUploadPermissions(card.slug)
        );
        return hasAnyCardPermission;
    }) || [];

    // State for selected category
    const [categoria, setcategoria] = useState('');

    // Set default category when categories or permissions change
    useEffect(() => {
        if (categoriasDisponibles.length === 0) {
            setcategoria('');
            return;
        }

        // If current selection is still valid, keep it
        if (categoriasDisponibles.find(cat => cat.name === categoria)) {
            return;
        }

        // Priority order for default selection
        let defaultCategory = '';
        
        if (hasArriendosPermission && categoriasDisponibles.find(cat => cat.name === 'Arriendo')) {
            defaultCategory = 'Arriendo';
        } else if (categoriasDisponibles.find(cat => cat.name === 'Canal Moderno')) {
            defaultCategory = 'Canal Moderno';
        } else if (categoriasDisponibles.find(cat => cat.name === 'Canal Tradicional')) {
            defaultCategory = 'Canal Tradicional';
        } else {
            defaultCategory = categoriasDisponibles[0]?.name || '';
        }

        setcategoria(defaultCategory);
    }, [rex_cards_upload_file, rex_data_permissions_user, hasArriendosPermission]);

    // Get selected category data with permission filtering
    const categoriaSeleccionada = categoriasDisponibles.find(cat => cat.name === categoria);
    
    // Filter cards that the user has permission to access
    const cardsAccesibles = categoriaSeleccionada?.cards?.filter(card => {
        if (!card.slug) return false;
        
        // For Arriendos category, all cards should be accessible if user has peru.arriendos
        if (categoria === 'Arriendo' && hasArriendosPermission) {
            return true;
        }
        
        // For other categories, check specific card permissions
        return hasFileUploadPermissions(card.slug);
    }) || [];

    // Generate descriptive message when category is selected but no cards are accessible
    const getNoAccessMessage = () => {
        if (categoria === 'Arriendo' && hasArriendosPermission && cardsAccesibles.length === 0) {
            return `Tienes permisos para acceder a "${categoria}", pero actualmente no hay funcionalidades disponibles. Contacta al administrador para habilitar las opciones de carga de arriendos.`;
        }
        
        if (categoria && cardsAccesibles.length === 0) {
            const categoryData = rex_cards_upload_file?.find(cat => cat.name === categoria);
            const requiredPermissions = categoryData?.cards?.map(card => card.slug).filter(Boolean) || [];
            
            return `No tienes los permisos necesarios para acceder a las funcionalidades de "${categoria}". Se requieren permisos para: ${requiredPermissions.join(', ')}. Contacta al administrador para solicitar acceso.`;
        }
        
        return 'No hay funcionalidades disponibles en esta categoría.';
    };

    return (
        <div className="Container-Main Container-File-Upload">
            <Row>
                <Col span={24}>
                    <Affix offsetTop={16}>
                        <div className="Container-Button-Status" style={{ "paddingTop": "0.3rem" }}>
                            <NavegadorArriendos />
                        </div>
                    </Affix>
                </Col>
            </Row>
            
            {/* Only show category buttons if there are available categories */}
            {categoriasDisponibles.length > 0 && (
                <Row>
                    <Col span={24}>
                        <Affix offsetTop={36}>
                            <div className="Container-Button-Status">
                                {categoriasDisponibles.map(cat =>
                                    <button
                                        key={cat.name}
                                        className={`Button-Status ${categoria === cat.name ? 'Active-Status-Button' : ''}`}
                                        onClick={() => setcategoria(cat.name)}
                                    >
                                        <span className="Text-Span">{cat.name}</span>
                                        <span className="Text-Span-Table-Status">{cat.name}</span>
                                        <div className="Circle-Button-Table-Status"></div>
                                    </button>
                                )}
                            </div>
                        </Affix>
                    </Col>
                </Row>
            )}

            <Row style={{ rowGap: '24px', marginTop: '2rem' }}>
                <Col xl={17} lg={15} md={24} xs={24}>
                    {categoriasDisponibles.length > 0 && categoria && cardsAccesibles.length > 0 ? (
                        <Row gutter={{ xs: 0, sm: 20 }} style={{ margin: '0', rowGap: '20px', marginBottom: '5px' }}>
                            {cardsAccesibles.map((item, indexItem) => {
                                return funPermisosObtenidos(
                                    rex_data_permissions_user,
                                    item.slug,
                                    <Col key={indexItem} style={{ maxHeight: '290px', height: '270px' }} className="gutter-row" xl={6} lg={12} sm={12} xs={24}>
                                        {
                                            rex_data_user_logingrow.usuusuario === "rosmar.c.requena@kcc.com" ||
                                                rex_data_user_logingrow.usuusuario === "milagros.cordova@grow-analytics.com.pe" ||
                                                rex_data_user_logingrow.usuusuario === "admin@admin.com" ||
                                                rex_data_user_logingrow.usuusuario === "Frank.Martinez@grow-analytics.com.pe"
                                                ? categoria === "Area 1" && item.title === "Master de Producto"
                                                    ? null
                                                    : item.title === "Master de Clientes"
                                                        ? <CardFile
                                                            title={"Objetivos Sell Out"}
                                                            subtitle={item.subtitle}
                                                            url={item.url}
                                                            disabled={item.disabled}
                                                            template={item.fileTemplate}
                                                            mode={item.mode}
                                                            area={categoria}
                                                            categoria={item.categoria}
                                                        />
                                                        : <CardFile
                                                            title={item.title}
                                                            subtitle={item.subtitle}
                                                            url={item.url}
                                                            template={item.fileTemplate}
                                                            disabled={item.disabled}
                                                            mode={item.mode}
                                                            area={categoria}
                                                            categoria={item.categoria}
                                                        />
                                                : <CardFile
                                                    title={item.title}
                                                    subtitle={item.subtitle}
                                                    url={item.url}
                                                    disabled={item.disabled}
                                                    template={item.fileTemplate}
                                                    mode={item.mode}
                                                    area={categoria}
                                                    categoria={item.categoria}
                                                />
                                        }
                                    </Col>
                                );
                            })}
                        </Row>
                    ) : categoriasDisponibles.length === 0 ? (
                        /* Show message when no categories are available */
                        <Row style={{ width: '100%', textAlign: 'center', padding: '40px 0' }}>
                            <Col span={24}>
                                <div style={{ color: '#666', fontSize: '16px', lineHeight: '1.5', maxWidth: '500px', margin: '0 auto' }}>
                                    <div style={{ marginBottom: '10px', fontWeight: '500' }}>
                                        🚫 Sin acceso a categorías
                                    </div>
                                    <div>
                                        No tienes permisos para acceder a ninguna categoría de carga de archivos. 
                                        Contacta al administrador del sistema para solicitar los permisos necesarios.
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    ) : (
                        /* Show descriptive message when category is selected but no cards are accessible */
                        <Row style={{ width: '100%', textAlign: 'center', padding: '40px 0' }}>
                            <Col span={24}>
                                <div style={{ color: '#666', fontSize: '16px', lineHeight: '1.5', maxWidth: '600px', margin: '0 auto' }}>
                                    <div style={{ marginBottom: '10px', fontWeight: '500' }}>
                                        ⚠️ Funcionalidades no disponibles
                                    </div>
                                    <div>
                                        {getNoAccessMessage()}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}
                </Col>
                
                <Col xl={7} lg={9} md={24} xs={24}>
                    <Row gutter={{ xs: 0, sm: 20 }} style={{ margin: '0', height: '100%' }}>
                        <Col className="gutter-row" span={24}>
                            <CardNotificationFile
                                itemNotification={rex_messages_notifications_upload_files}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>

            {rex_users_file_upload_connected &&
                <SideMenu
                    usersCurrentView={rex_users_file_upload_connected}
                    usersAllConnected={rex_data_users_online}
                />
            }

            {rex_show_notification_modal_upload_file && 
                <ModalItemNotification style={{ marginTop: '2rem' }} />
            }
        </div>
    )
}

export default FileUpload